/**
 * @generated SignedSource<<3c86d54d7364357673fcf7ea15280ecf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorecastDeviceInputMode = "SIGNAGE" | "TOUCH";
export type AddScreenInfoQuery$variables = {
  screenId?: string | null;
};
export type AddScreenInfoQuery$data = {
  readonly storecast: {
    readonly screen: {
      readonly inputMode: StorecastDeviceInputMode | null;
      readonly " $fragmentSpreads": FragmentRefs<"InfoBox_StorecastScreen" | "StorecastScreenAdminModeSelector_StorecastScreen">;
    };
  };
};
export type AddScreenInfoQuery = {
  response: AddScreenInfoQuery$data;
  variables: AddScreenInfoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "screenId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "screenId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "inputMode",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddScreenInfoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Storecast",
        "kind": "LinkedField",
        "name": "storecast",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StorecastScreen",
            "kind": "LinkedField",
            "name": "screen",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "InfoBox_StorecastScreen"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StorecastScreenAdminModeSelector_StorecastScreen"
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddScreenInfoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Storecast",
        "kind": "LinkedField",
        "name": "storecast",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StorecastScreen",
            "kind": "LinkedField",
            "name": "screen",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StorecastDeviceInfo",
                "kind": "LinkedField",
                "name": "info",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "language",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "languageStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resolution",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resolutionStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "time",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timeStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timeZone",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timeZoneStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userAgentStatus",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recommendedInputMode",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "faaa07afd19c503ef9c7dd40c74e9970",
    "id": null,
    "metadata": {},
    "name": "AddScreenInfoQuery",
    "operationKind": "query",
    "text": "query AddScreenInfoQuery(\n  $screenId: ID\n) {\n  storecast {\n    screen(id: $screenId) {\n      ...InfoBox_StorecastScreen\n      ...StorecastScreenAdminModeSelector_StorecastScreen\n      inputMode\n      id\n    }\n  }\n}\n\nfragment InfoBox_StorecastScreen on StorecastScreen {\n  id\n  info {\n    language\n    languageStatus\n    resolution\n    resolutionStatus\n    time\n    timeStatus\n    timeZone\n    timeZoneStatus\n    userAgentStatus\n  }\n}\n\nfragment StorecastScreenAdminModeSelector_StorecastScreen on StorecastScreen {\n  id\n  inputMode\n  recommendedInputMode\n}\n"
  }
};
})();

(node as any).hash = "a6edec4166b75c33142f58d66b9fe964";

export default node;
